/*
 * IconListContext  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { IIconPackageURLMapping } from "@adapptio/lib-components";
import { ICON_SIZE } from "../Icon";

export interface IIconListContextValue {
	search?: string;
	setSearch?: (search: string) => void;
	urlMapping?: IIconPackageURLMapping;
	iconPreviewSize?: ICON_SIZE;
	selectedPackName?: string;
	selectedIconName?: string;
	onIconSelect?: (packName: string, iconName: string) => void;
}

export const IconListContext = React.createContext<IIconListContextValue>({});

export function useIconListContext(): IIconListContextValue {
	return useContext(IconListContext);
}
